import Link from 'next/link'
import classnames from 'classnames'
import { CSSProperties, FC } from 'react'

import { TextCol, Typography, Flex } from '~ui'
import { CardProps } from './banner.type'

import styles from './Banner.module.scss'

const { Text } = Typography

const Card: FC<CardProps & { flexible?: boolean }> = ({
  link,
  title,
  imageUrl,
  flexible,
  fields,
}) => (
  <div
    className={classnames(styles.card, { [styles.flexible]: flexible })}
    style={{ '--image-url': `url(${imageUrl})` } as CSSProperties}
    key={title}
  >
    <Text bold>
      <Link legacyBehavior href={link}>
        <a className={styles.link}>{title}</a>
      </Link>
      {fields && (
        <Flex flexDirection="column">
          {fields.map((field) => (
            <TextCol key={field[0].text} fields={field} />
          ))}
        </Flex>
      )}
    </Text>
  </div>
)

export default Card
